export default __webpack_public_path__ + "static/media/product-13.a99de275.jpg";